import { useEffect, useRef, useState } from "react";
import useAxiosPrivate from "hooks/useAxiosPrivate";

import useBackendError from "hooks/useBackendError";
import OngoingQapis from "pages/qapi/overview/OngoingQapis";

const PastQAPI = ({ residentId, showLess }) => {
  const [isLoading, setLoading] = useState(true);
  const { setError } = useBackendError();
  const axios = useAxiosPrivate();
  const data = useRef([]);

  const loadData = async () => {
    setLoading(true);

    try {
      const response = await axios.get(`/qapi/list?residentId=${residentId}`, {
        headers: { "Content-Type": "application/json" },
      });
      data.current = response.data;
    } catch (err) {
      setError("Failed to fetch from the backend. Please try again");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadData();
  }, []);

  return <OngoingQapis data={data.current} isLoading={isLoading} showLess={showLess} />;
};
export default PastQAPI;
